<template>
	<div v-if="$can('view', 'dashboard')">
		<Transaction :monthly="monthly" :daily="daily" :remaining="remaining" :saleSum="saleSum"/><br>
		<b-row>
			<b-col cols="12">
				<PieChart :monthly="monthly" :daily="daily"/>
			</b-col>
		</b-row>
		<br>
		<b-row>
			<b-col cols="12">
				<RemainingVue :remaining="remaining" :saleSum="saleSum"/>
			</b-col>
		</b-row>
		<br>
		<b-row>
			<b-col cols="12">
				<GroupDashboard :groupList="groupList"/>
			</b-col>
		</b-row>
		<br>
		<b-row>
			<b-col cols="12">
				<Cashiers/>
			</b-col>
		</b-row>
	</div>
</template>
<script>
import ReportService from "@/views/analytics/otchot/report.service";
import Bar  from 'vue-chartjs'
import Transaction from "./componentsForDashbords/transaction";
import PieChart from "@/views/dashboard-analytics/pieChart.vue";
import RemainingVue from "@/views/components/charts/RemainingVue.vue";
import GroupDashboard from "@/views/components/charts/GroupDashboard.vue";
import Cashiers from "@/views/components/charts/cashiers.vue";
import RefundService from "@/services/refund.service";
export default {
	components:{
		Cashiers,
		GroupDashboard,
		Bar,
		Transaction,
		PieChart,
		RefundService,
		RemainingVue
	},
	data(){
		return{
			monthly:[],
			daily:[],
			remaining:[],
			saleSum:[],
			employees:[],
			groupList:[],
			payload: {
				page: 1,
				limit: 10,
				keyword: ''
			}
		}
	},
	props :{

	},
	methods:{
		async getList() {
			await RefundService.getSaleList(this.payload).then(res => {
				this.items = res.data
			})
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		}
	},
	async created() {
		this.getList()
		await ReportService.getDifferentMonthlyReport().then(res => {
			this.monthly = res.data
		}).catch(e => {
		})
		await ReportService.getDifferentDailyReport().then(res => {
			this.daily = res.data
		}).catch(e => {
		})
		await ReportService.getRemainingReport().then(res => {
			this.remaining = res.data
		}).catch(e => {
		})
		await ReportService.dailySaleSum().then(res => {
			this.saleSum = res.data
		})
		await ReportService.getRemainingByGroup().then(res => {
			this.groupList = res.data
		})

	}
}
</script>
